import { type z } from 'zod'

import { type schemas } from '~interface/zod-schema'

import { type BillStep1 } from './cases'
import { type FormStyleElement } from './formData'
import { type InputSubstep2 } from './processes'

export type FormStep0 = z.infer<typeof schemas.FormStep0>
export type InputStepChoiceData = z.infer<typeof schemas.InputStepChoiceData>
export type InputStepChoice1 = z.infer<typeof schemas.InputStepChoice1>
export type ProcessCase3 = z.infer<typeof schemas.ProcessCase3>
export type ProcessStage = z.infer<typeof schemas.ProcessStage>
export type ProcessStageStatus = z.infer<typeof schemas.CompleteEnum>
export type SectionSubstep0 = z.infer<typeof schemas.SectionSubstep0>

export function isBillStep(step: FormStep0 | BillStep1): boolean {
  return 'charges' in step
}

export function isInputStep(step: InputSubstep2 | SectionSubstep0 | FormStyleElement): boolean {
  return 'type' in step && 'style' in step && 'pinned' in step
}

export function isFormStyleElement(
  element: FormStyleElement | InputSubstep2 | SectionSubstep0,
): boolean {
  return 'type' in element && element.type === 'page_break'
}
